import type { ReactElement } from 'react'
import React from 'react'

import { bgColor, textColor } from '@ui-kit/styles/colors'

import * as styles from './styles'
import type { WebProps } from './types'

const Avatar = (props: WebProps): ReactElement => {
  const { container, circle, iconContainer, textContainer, initials, title, subtitle } =
    styles.avatar({ interactive: Boolean(props.onClick) })
  return (
    <div key={props.id} className={container()} data-testid={props.id} onClick={props.onClick}>
      <div className={circle({ className: bgColor({ color: props.bgColor ?? 'grey200' }) })}>
        <span
          className={initials({
            className: textColor({ color: props.initialsColor ?? 'deepForest' }),
          })}
        >
          {props.initials}
        </span>
        {props.icon && <div className={iconContainer()}>{props.icon}</div>}
      </div>
      {(props.title || props.subtitle) && (
        <div className={textContainer()}>
          {props.title && <p className={title()}>{props.title}</p>}
          {props.subtitle && <p className={subtitle()}>{props.subtitle}</p>}
        </div>
      )}
    </div>
  )
}

export default Avatar
